import useCountUp from "../../lib/useCountUp";
import { HotspotMap } from "../visuals/HotspotMap";
import { SectionNumber } from "../visuals/SectionNumber";
import { LiveActivationsBadge } from "../visuals/LiveActivationsBadge";

export const Impact = () => {
    return (
        <section
            id="impact"
            data-testid="impact-section"
            className="relative bg-[#0A1428] text-white py-28 md:py-36 overflow-hidden"
        >
            <SectionNumber n={6} total={12} theme="dark" />
            <div className="absolute inset-0 dot-grid-light opacity-40 pointer-events-none" />
            {/* Abstract hotspot map */}
            <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-[80%] pointer-events-none opacity-70">
                <HotspotMap />
            </div>
            {/* Mountain motif from logo */}
            <div className="absolute -bottom-10 left-0 right-0 h-64 pointer-events-none opacity-[0.07]">
                <svg
                    viewBox="0 0 1200 200"
                    preserveAspectRatio="none"
                    className="w-full h-full"
                >
                    <polygon points="0,200 320,40 540,200" fill="#3B82F6" />
                    <polygon points="420,200 760,30 1200,200" fill="#F0493E" />
                </svg>
            </div>

            <div className="relative max-w-7xl mx-auto px-6 md:px-12">
                <div className="reveal max-w-3xl">
                    <span className="text-xs md:text-sm font-bold uppercase tracking-[0.28em] text-[#F0493E]">
                        Mission · Access
                    </span>
                    <h2 className="mt-6 font-display font-extrabold text-4xl md:text-6xl leading-[0.98] tracking-tighter text-balance">
                        We measure our work in
                        <br />
                        the same unit as our mission:
                        <br />
                        <span className="text-[#F0493E]">reliable access.</span>
                    </h2>
                </div>

                <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
                    <Counter
                        end={24}
                        prefix=""
                        suffix="/7"
                        label="Around-the-clock availability inside every Kairos-equipped space."
                        testid="impact-counter-1"
                    />
                    <StaticStat
                        value="OTC"
                        label="Naloxone is now over-the-counter across the U.S. — no prescription required."
                        testid="impact-counter-2"
                    />
                    <StaticStat
                        value="INSTANT"
                        label="dispense time per Kairos unit — and the next dose auto-reloads for the next use."
                        testid="impact-counter-3"
                    />
                </div>

                <div className="reveal mt-16 max-w-3xl text-base md:text-lg text-slate-300 leading-relaxed font-medium">
                    Kairos ORD is a mission-driven company. Every deployment
                    is instrumented to measure availability, dispense time,
                    and on-site accessibility — turning each unit into
                    evidence for the next deployment.
                </div>
                <div className="reveal mt-6 text-[10px] font-bold uppercase tracking-[0.22em] text-slate-500">
                    Sources · FDA · CDC · HHS
                </div>

                <LiveActivationsBadge />
            </div>
        </section>
    );
};

const Counter = ({ end, suffix = "", prefix = "", label, testid }) => {
    const [ref, value] = useCountUp(end);
    return (
        <div
            ref={ref}
            data-testid={testid}
            className="bg-[#0A1428] p-8 md:p-12"
        >
            <div className="font-display font-extrabold text-6xl md:text-7xl tnum tracking-tighter">
                {prefix}
                {value.toLocaleString()}
                <span className="text-[#F0493E]">{suffix}</span>
            </div>
            <p className="mt-6 text-sm md:text-base text-slate-400 leading-relaxed font-medium max-w-xs">
                {label}
            </p>
        </div>
    );
};

const StaticStat = ({ value, label, testid }) => (
    <div data-testid={testid} className="bg-[#0A1428] p-8 md:p-12">
        <div className="font-display font-extrabold text-6xl md:text-7xl tracking-tighter text-[#F0493E]">
            {value}
        </div>
        <p className="mt-6 text-sm md:text-base text-slate-400 leading-relaxed font-medium max-w-xs">
            {label}
        </p>
    </div>
);
